import { MainLayoutSection } from 'presentation/ui/layouts/main-layout/main-layout-section/MainLayoutSection';
import { MainLayoutSectionSection } from 'presentation/ui/layouts/main-layout/main-layout-section/MainLayoutSectionSection';
import { ViewLayout } from 'presentation/ui/layouts/view-layout/ViewLayout';
import { ViewLayoutSection } from 'presentation/ui/layouts/view-layout/view-layout-section/ViewLayoutSection';
import { useContext } from 'react';
import { useTypedSelector } from '../../../../store/common/TypedSelector';
import { ClientContext } from '../../../core/context/ClientContext';
import { FacilityContext } from '../../../core/context/FacilityContext';
import { ContainerViewModel } from '../../domain/model/ContainerModel';
import { GeneratorEluateIsotope } from '../../domain/model/isotopes/GeneratorEluateIsotope';
import { GeneratorTypeIsotope } from '../../domain/model/isotopes/GeneratorTypeIsotope';
import { selectApprovedContainers } from '../../store/containerSlice';
import { selectInWastemanagementCyclotronProducts } from '../../store/cyclotronProductSlice';
import { selectInWastemanagementEluates } from '../../store/eluateSlice';
import { selectGenerators } from '../../store/generatorSlice';
import { ContainerCollection } from '../ui/card-collections/container-collection/ContainerCollection';
import { ContainersByNuclide } from './ContainersByNuclideType';

export const ApprovedContainersView = (): JSX.Element => {

	 const clientContext = useContext(ClientContext);
	const facilityContext = useContext(FacilityContext);

	const approvedContainers = useTypedSelector(selectApprovedContainers(
		clientContext.selectedClientUuid,
		facilityContext.selectedFacilityUuid
	));

	const inWastemanagementCyclotronProducts = useTypedSelector(selectInWastemanagementCyclotronProducts(
		clientContext.selectedClientUuid,
		facilityContext.selectedFacilityUuid
	));

	const inWastemanagementEluates = useTypedSelector(selectInWastemanagementEluates());

	const generators = useTypedSelector(selectGenerators(
		clientContext.selectedClientUuid,
		facilityContext.selectedFacilityUuid
	));

	inWastemanagementEluates.forEach(eluate => {

		const inWastemanagementEluateGenerator = generators.find((generator) => {
			return generator.Uuid === eluate.Generator;
		});
		if (inWastemanagementEluateGenerator.Isotope === GeneratorTypeIsotope.MOLYBDENUM_99_MO) {
			eluate.Isotope = GeneratorEluateIsotope.TECHNETIUM_99M_TC;
		} else {
			eluate.Isotope = GeneratorEluateIsotope.GALLIUM_68_GA;
		}
	});

	const containersByNuclides: Array<ContainersByNuclide> = [];
	let containersMixedNuclideIds: string[] = [];

	approvedContainers.forEach((approvedContainer: ContainerViewModel) => {

		if (approvedContainer.CyclotroneProductIds.length === 0 && approvedContainer.GeneratorEluatIds.length !== 0 ) {

			const approvedContainerEluates = inWastemanagementEluates.filter(value => approvedContainer.GeneratorEluatIds.includes(value.Uuid));
			const checkEluates = approvedContainerEluates.every((item) => {
				return item.Isotope === approvedContainerEluates[0].Isotope;
			});

			if (checkEluates) {
				const existingEluateContainerByNuclide = containersByNuclides.find((e) =>
					e.Nuclide === approvedContainerEluates[0].Isotope
				);
				if (existingEluateContainerByNuclide) {
					existingEluateContainerByNuclide.Containers.push(approvedContainer);
				} else {
					const newEluateContainerByNuclide: ContainersByNuclide = {
						Nuclide: approvedContainerEluates[0].Isotope,
						Containers: []
					};
					newEluateContainerByNuclide.Containers.push(approvedContainer);
					containersByNuclides.push(newEluateContainerByNuclide);
				}
			} else {
				const existingMixedContainerByNuclides = containersByNuclides.find((e) => e.Nuclide === 'GemischterContainer');
				if (existingMixedContainerByNuclides) {
					existingMixedContainerByNuclides.Containers.push(approvedContainer);
				} else {
					const newMixedContainerByNuclide: ContainersByNuclide = {
						Nuclide: 'GemischterContainer',
						Containers: []
					};
					newMixedContainerByNuclide.Containers.push(approvedContainer);
					containersByNuclides.push(newMixedContainerByNuclide);
				}
			}
		}

		if (approvedContainer.CyclotroneProductIds.length !== 0 && approvedContainer.GeneratorEluatIds.length === 0) {

			const approvedContainerCyclotronProducts = inWastemanagementCyclotronProducts.filter(
				value => approvedContainer.CyclotroneProductIds.includes(value.Uuid));
			const checkCyclotronProducts = approvedContainerCyclotronProducts.every((item) => {
				return item.Isotope === approvedContainerCyclotronProducts[0].Isotope;
			});
			if (checkCyclotronProducts) {
				const existingCyclotronProductContainerByNuclide = containersByNuclides.find(
					(e) => e.Nuclide === approvedContainerCyclotronProducts[0].Isotope);

				if (existingCyclotronProductContainerByNuclide) {
					existingCyclotronProductContainerByNuclide.Containers.push(approvedContainer);
				} else {
					const newCyclotronProductContainerByNuclide: ContainersByNuclide = {
						Nuclide: approvedContainerCyclotronProducts[0].Isotope,
						Containers: []
					};
					newCyclotronProductContainerByNuclide.Containers.push(approvedContainer);
					containersByNuclides.push(newCyclotronProductContainerByNuclide);
				}
			} else {
				const existingMixedContainerByNuclides = containersByNuclides.find((e) => e.Nuclide === 'GemischterContainer');
				if (existingMixedContainerByNuclides) {
					existingMixedContainerByNuclides.Containers.push(approvedContainer);
				} else {
					const newMixedContainerByNuclide: ContainersByNuclide = {
						Nuclide: 'GemischterContainer',
						Containers: []
					};
					newMixedContainerByNuclide.Containers.push(approvedContainer);
					containersByNuclides.push(newMixedContainerByNuclide);
				}
			}
		}

		if (approvedContainer.CyclotroneProductIds.length !== 0 && approvedContainer.GeneratorEluatIds.length !== 0) {
			containersMixedNuclideIds = containersMixedNuclideIds.concat(approvedContainer.GeneratorEluatIds, approvedContainer.CyclotroneProductIds);
			const existingMixedContainerByNuclides = containersByNuclides.find((e) => e.Nuclide === 'GemischterContainer');
			if (existingMixedContainerByNuclides) {
				existingMixedContainerByNuclides.Containers.push(approvedContainer);
			} else {
				const newMixedContainerByNuclide: ContainersByNuclide = {
					Nuclide: 'GemischterContainer',
					Containers: []
				};
				newMixedContainerByNuclide.Containers.push(approvedContainer);
				containersByNuclides.push(newMixedContainerByNuclide);
			}
		}
	});

	return (
		<MainLayoutSection section={MainLayoutSectionSection.SECTION_MAIN}>
			<ViewLayout>
				<ViewLayoutSection>
					<ContainerCollection containersByNuclides={containersByNuclides} />
				</ViewLayoutSection>
			</ViewLayout>
		</MainLayoutSection>
	);
};
